import IconDoubleArrowUp from "@shared/components/icons/DoubleArrowUp"

interface Props {
  /** Whether this lesson is currently opened up against the planner's collapse-all. */
  isExpanded: boolean
  toggle: () => void
}

/**
 * Opens one lesson while the planner's collapse-all keeps the rest showing only their titles.
 * Without it, collapse-all would be a one-way door.
 */
export default function ExpandCollapseButton({ isExpanded, toggle }: Props) {
  const label = isExpanded ? "Collapse" : "Expand"
  // The same glyph both ways: expanding points down, collapsing points back up.
  const arrow = <IconDoubleArrowUp className={isExpanded ? "h-3 w-3" : "h-3 w-3 rotate-180"} />

  return (
    <div className="flex justify-center">
      <button
        type="button"
        onClick={toggle}
        data-test="expand collapse lesson"
        className="flex h-6 cursor-pointer items-center gap-1.5 rounded-full bg-white px-3 text-[0.84375rem] font-semibold shadow-md hover:text-link-blue"
      >
        {arrow}
        {label}
        {arrow}
      </button>
    </div>
  )
}
